// Generated by purs version 0.12.3
"use strict";
var Web_DOM_CharacterData = require("../Web.DOM.CharacterData/index.js");
var Web_DOM_ChildNode = require("../Web.DOM.ChildNode/index.js");
var Web_DOM_Comment = require("../Web.DOM.Comment/index.js");
var Web_DOM_DOMTokenList = require("../Web.DOM.DOMTokenList/index.js");
var Web_DOM_Document = require("../Web.DOM.Document/index.js");
var Web_DOM_DocumentFragment = require("../Web.DOM.DocumentFragment/index.js");
var Web_DOM_DocumentType = require("../Web.DOM.DocumentType/index.js");
var Web_DOM_Element = require("../Web.DOM.Element/index.js");
var Web_DOM_HTMLCollection = require("../Web.DOM.HTMLCollection/index.js");
var Web_DOM_Node = require("../Web.DOM.Node/index.js");
var Web_DOM_NodeList = require("../Web.DOM.NodeList/index.js");
var Web_DOM_NodeType = require("../Web.DOM.NodeType/index.js");
var Web_DOM_NonDocumentTypeChildNode = require("../Web.DOM.NonDocumentTypeChildNode/index.js");
var Web_DOM_NonElementParentNode = require("../Web.DOM.NonElementParentNode/index.js");
var Web_DOM_ParentNode = require("../Web.DOM.ParentNode/index.js");
var Web_DOM_ProcessingInstruction = require("../Web.DOM.ProcessingInstruction/index.js");
var Web_DOM_Text = require("../Web.DOM.Text/index.js");
module.exports = {};
